import { List, User, Plus } from 'tabler-icons-react';
import { Names } from 'Utils';
import { UserSidebarItem } from 'Elements';
import styles from 'partials/dashboard/user-sidebar.module.scss';

export const UserSidebar = () => {
	const menus = {
		profile: {
			icon: User
		},
		content: {
			icon: List
		},
		upload: {
			icon: Plus
		}
	};
	return (
		<div className={styles.sidebar}>
			<ul className={styles.listSidebar}>
				{Object.keys(menus).map((menu, idx) => {
					return (
						<UserSidebarItem
							key={idx}
							title={Names[menu].name}
							icon={menus[menu].icon}
							linkUrl={Names[menu].path}
						/>
					);
				})}
			</ul>
		</div>
	);
};
